import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';

export const useTransactionClock = () => {
  const [serverTime, setServerTime] = useState(null);
  const [error, setError] = useState(false);
  const anchor = useRef(null);
  const mounted = useRef(false);
  const inFlight = useRef(false);
  const refresh = useCallback(async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    try {
      const { data } = await api.get('/transactions/clock');
      const milliseconds = Date.parse(data.serverTime);
      if (!Number.isFinite(milliseconds)) throw new Error('Invalid server clock');
      if (!mounted.current) return;
      anchor.current = { milliseconds, at: performance.now() };
      setServerTime(new Date(milliseconds).toISOString());
      setError(false);
    } catch {
      if (mounted.current) setError(true);
    } finally { inFlight.current = false; }
  }, []);

  useEffect(() => {
    mounted.current = true;
    refresh();
    const tick = setInterval(() => {
      if (anchor.current) {
        const { milliseconds, at } = anchor.current;
        setServerTime(new Date(milliseconds + performance.now() - at).toISOString());
      }
    }, 1000);
    const sync = setInterval(refresh, 60000);
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      mounted.current = false;
      clearInterval(tick); clearInterval(sync);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [refresh]);
  return { serverTime, error, refresh };
};